module.exports = __webpack_public_path__ + "img/Icon-Share.b906dcf7.svg";